import { useState } from 'react'
import { useLanguage } from '../context/LanguageContext'

const ROW_KEYS = [
  [
    { id: 'oasis',    image: '/assets/sell/OASIS.jpeg',        link: '#', defaultActive: true },
    { id: 'ghaf',     image: '/assets/sell/ghaf-woods.jpg',    link: '#', defaultActive: false },
  ],
  [
    { id: 'nad',      image: '/assets/sell/nad_al_sheba.jpg',  link: '#', defaultActive: false },
    { id: 'district', image: '/assets/sell/district-one.jpg',  link: '#', defaultActive: true },
  ],
]




const partners = [
  { src: '/dev_logos/Azizi.png', alt: 'Azizi', scale: 0.8 },
  { src: '/dev_logos/Binghatti.png', alt: 'Binghatti', scale: 1.3 },
  { src: '/dev_logos/Damac.png', alt: 'Damac', scale: 1.15 },
  { src: '/dev_logos/Danube.png', alt: 'Danube', scale: 1.9 },
  { src: '/dev_logos/DubaiHolding.png', alt: 'Dubai Holding', scale: 1.4 },
  { src: '/dev_logos/DubaiProperties.png', alt: 'Dubai Properties', scale: 1.1 },
  { src: '/dev_logos/Ellington.png', alt: 'Ellington', scale: 1.3 },
  { src: '/dev_logos/Emaar.png', alt: 'Emaar', scale: 1.6 },
  { src: '/dev_logos/Nakheel.png', alt: 'Nakheel', scale: 1.7 },
  { src: '/dev_logos/Sobha.png', alt: 'Sobha', scale: 1.0 },
]

const NAVY = '#002E53'
const GOLD = '#C5A059'
const IMAGE_H = 320

/* ─────────────────────────────────────────────────────────
   Desktop: Hover-expand sliding row (unchanged behaviour)
───────────────────────────────────────────────────────── */
function SlidingRow({ boxes, learnMore }) {
  const [activeId, setActiveId] = useState(
    boxes.find((b) => b.defaultActive)?.id ?? boxes[0].id
  )

  return (
    <div className="sliding-row-outer">
      {boxes.map((box) => {
        const isActive = box.id === activeId
        return (
          <div
            key={box.id}
            onMouseEnter={() => setActiveId(box.id)}
            style={{
              position: 'relative',
              flex: isActive ? '2 1 0' : '1 1 0',
              transition: 'flex 0.55s cubic-bezier(0.4,0,0.2,1)',
              cursor: isActive ? 'default' : 'pointer',
              overflow: 'hidden',
              borderRadius: '10px',
              height: '100%',
            }}
          >
            {/* Background image */}
            <div style={{
              position: 'absolute',
              inset: 0,
              backgroundImage: `url(${box.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transition: 'transform 0.5s ease',
              transform: isActive ? 'scale(1.03)' : 'scale(1)',
              borderRadius: '10px',
            }} />

            {/* Slide-in text panel */}
            <div style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '50%',
              height: '100%',
              backgroundColor: '#ffffff',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: '28px 32px',
              boxSizing: 'border-box',
              overflow: 'hidden',
              opacity: isActive ? 1 : 0,
              transform: isActive ? 'translateX(0)' : 'translateX(100%)',
              transition: 'transform 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease',
            }}>
              <h4 style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: '18px',
                fontWeight: 600,
                color: NAVY,
                margin: '0 0 10px 0',
                lineHeight: '1.35em',
              }}>{box.title}</h4>
              <p style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: '13px',
                fontWeight: 400,
                color: '#4a5568',
                margin: '0 0 16px 0',
                lineHeight: '1.6em',
              }}>{box.description}</p>
              <a
                href={box.link}
                className="partners-learn-more"
                style={{
                  display: 'inline-block',
                  backgroundColor: NAVY,
                  color: '#ffffff',
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: '13px',
                  fontWeight: 500,
                  padding: '9px 20px',
                  borderRadius: '4px',
                  textDecoration: 'none',
                  width: 'fit-content',
                  whiteSpace: 'nowrap',
                  transition: 'background 0.2s',
                }}
              >
                { learnMore }
               
              </a>
            </div>
          </div>
        )
      })}
    </div>
  )
}

/* ─────────────────────────────────────────────────────────
   Mobile: Simple property card (image + text stacked)
───────────────────────────────────────────────────────── */
function MobilePropertyCard({ box, learnMoreArrow }) {
  return (
    <a href={box.link} style={{ textDecoration: 'none', display: 'block' }}>
      <div
        className="mobile-prop-card"
        style={{
          borderRadius: '12px',
          overflow: 'hidden',
          border: '1px solid rgba(0,46,83,0.08)',
          backgroundColor: '#fff',
          boxShadow: '0 2px 16px rgba(0,0,0,0.05)',
          transition: 'transform 0.25s ease, box-shadow 0.25s ease',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'translateY(-4px)'
          e.currentTarget.style.boxShadow = `0 8px 28px rgba(197,160,89,0.15)`
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'translateY(0)'
          e.currentTarget.style.boxShadow = '0 2px 16px rgba(0,0,0,0.05)'
        }}
      >
        {/* Image */}
        <div style={{
          width: '100%',
          height: '170px',
          backgroundImage: `url(${box.image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }} />

        {/* Text body */}
        <div style={{ padding: '18px 16px 20px' }}>
          <h4 style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: '14px',
            fontWeight: 600,
            color: NAVY,
            margin: '0 0 8px',
            lineHeight: '1.4em',
          }}>{box.title}</h4>
          <p style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: '12px',
            color: '#5a6577',
            lineHeight: '1.65em',
            margin: '0 0 12px',
          }}>{box.description}</p>
          <span style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: '12px',
            fontWeight: 600,
            color: GOLD,
          }}>
            { learnMoreArrow }
          </span>
        </div>
      </div>
    </a>
  )
}

/* ─────────────────────────────────────────────────────────
   Section wrapper
───────────────────────────────────────────────────────── */
function PartnersSection() {
  const { t } = useLanguage()

  // Build rows with translated titles / descriptions
  const rows = ROW_KEYS.map(rowDefs =>
    rowDefs.map(def => ({
      ...def,
      title: t(`partners.${def.id}.title`),
      description: t(`partners.${def.id}.desc`),
    }))
  )
  const allBoxes = rows.flat()
  return (
    <div style={{ backgroundColor: '#FFFFFF', width: '100%' }}>
      <style>{`
        .partners-learn-more:hover {
          background-color: #001f3a !important;
        }

        /* ── Heading ── */
        .partners-heading-row {
          display: flex;
          flex-direction: row;
          gap: 40px;
          padding: 60px 0 0px 0; /* Tightened gap under title */
          align-items: flex-end;
          flex-wrap: wrap;
        }
        /* ── Marquee ── */
        .partners-marquee-container {
          width: 100%;
          overflow: hidden;
          background-color: transparent;
          padding: 24px 0 32px 0; /* Safer padding for scaling, but visually tighter */
          margin: 0px 0 24px 0; /* Tightened gap above projects */
          display: flex;
          position: relative;
        }

        /* Gradient fading edges */
        .partners-marquee-container::before,
        .partners-marquee-container::after {
          position: absolute;
          top: 0;
          width: 200px;
          height: 100%;
          content: "";
          z-index: 2;
          pointer-events: none;
        }
        .partners-marquee-container::before {
          left: 0;
          background: linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0) 100%);
        }
        .partners-marquee-container::after {
          right: 0;
          background: linear-gradient(to left, #ffffff 0%, rgba(255,255,255,0) 100%);
        }

        .partners-marquee-track {
          display: flex;
          width: max-content;
          animation: marquee 30s linear infinite;
        }

        /* Hover pauses the track */
        .partners-marquee-container:hover .partners-marquee-track {
          animation-play-state: paused;
        }

        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .marquee-logo-link {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 220px; 
          height: 100px;
          margin: 0 50px;
          text-decoration: none;
          transition: transform 0.4s cubic-bezier(0.25, 1, 0.5, 1);
        }
        
        .marquee-logo-link img {
          max-height: 65px;
          max-width: 180px;
          object-fit: contain;
          filter: grayscale(100%) opacity(0.35);
          transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
          transform: scale(var(--logo-scale, 1));
        }

        .marquee-logo-link:hover {
          transform: translateY(-5px);
        }

        .marquee-logo-link:hover img {
          filter: grayscale(0%) opacity(1);
          transform: scale(calc(var(--logo-scale, 1) * 1.08));
        }

        /* ── Desktop sliding rows ── */
        .sliding-row-outer {
          display: flex;
          flex-direction: row;
          gap: 16px;
          width: 100%;
          height: ${IMAGE_H}px;
        }
        .partners-desktop-rows {
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding-bottom: 15px;
        }

        /* ── Mobile card grid (hidden on desktop) ── */
        .partners-mobile-grid { display: none; }

        /* ── Breakpoints ── */
        @media (max-width: 768px) {
          .partners-heading-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            padding: 40px 0 16px 0;
          }
        }

        @media (max-width: 700px) {
          /* Hide desktop layout, show mobile cards */
          .partners-desktop-rows { display: none !important; }
          .partners-mobile-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 14px;
            padding-bottom: 20px;
          }
        }

        @media (max-width: 400px) {
          .partners-mobile-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div style={{ maxWidth: '1300px', margin: '0 auto', padding: '0 20px', boxSizing: 'border-box' }}>

        {/* ── Heading row ── */}
        <div className="partners-heading-row">
          <div style={{ flex: '1 1 auto' }}>
            <div style={{ marginBottom: '8px' }}>
              <span style={{
                backgroundColor: 'rgba(197,160,89,0.1)',
                color: '#C5A059',
                fontFamily: "'Poppins', sans-serif",
                fontSize: '12px',
                fontWeight: 700,
                borderRadius: '5px',
                padding: '5px 8px',
                display: 'inline-block',
              }}>{ t('partners.tag') }</span>
            </div>
            <h2 style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: 'clamp(23px, 3.5vw, 44px)',
              fontWeight: 600,
              lineHeight: '1.2em',
              letterSpacing: '-0.3px',
              color: NAVY,
              margin: 0,
              maxWidth: '520px',
            }}>
              { t('partners.heading') }
            </h2>
          </div>
        </div>

        {/* ── Infinite Marquee ── */}
        <div className="partners-marquee-container">
          <div className="partners-marquee-track">
            {/* Double the list for seamless looping */}
            {[...partners, ...partners].map((p, i) => (
              <a
                key={i}
                href={`/offplan?developer=${encodeURIComponent(p.alt)}#projects`}
                className="marquee-logo-link"
                style={{ '--logo-scale': p.scale || 1 }}
              >
                <img src={p.src} alt={p.alt} />
              </a>
            ))}
          </div>
        </div>

        {/* ── Desktop: sliding rows ── */}
        <div className="partners-desktop-rows">
          {rows.map((rowBoxes, i) => (
            <SlidingRow key={i} boxes={rowBoxes} learnMore={t('partners.learnMore')} />
          ))}
        </div>

        {/* ── Mobile: simple card grid ── */}
        <div className="partners-mobile-grid">
          {allBoxes.map((box) => (
            <MobilePropertyCard key={box.id} box={box} learnMoreArrow={t('partners.learnMoreArrow')} />
          ))}
        </div>

      </div>
    </div>
  )
}

export default PartnersSection
